import React from "react";
import { Provider } from "react-redux";
import ct from "class-types.macro";
import CarouselMember from "./CarouselMember";
import { Product } from "~/common/Store/models/ProductListing";
import Store from "~/common/Store";
import Carousel from "~/common/Carousel";

interface Props {
  displayHeader?: boolean;
  displayShopAllLink?: boolean;
  headerText?: string;
  link?: string;
  items?: Product[];
  linkColor?: string;
  discountCode: string;
  containerClassNames?: string;
  imageUrl?: string;
}

const ProductCarouselContainer = ({
  displayHeader,
  displayShopAllLink,
  headerText,
  link,
  items,
  linkColor,
  discountCode,
  containerClassNames,
  imageUrl,
}: Props) => {
  const products = items || [];

  return (
    <Provider store={Store}>
      <div>
        {displayHeader && (
          <h3 className="header-3 clears text-2xl font-bold">
            <span style={{ marginRight: "15px" }}>{headerText}</span>
            {displayShopAllLink && (
              <a
                href={link}
                className="clears text-lg block xs:inline-block mt-2 xs:mt-0"
                style={{ color: linkColor }}
              >
                Shop All &nbsp;
                <i className="icon-breadcrumb" />
              </a>
            )}
          </h3>
        )}
        <div data-component="carousel" className={containerClassNames}>
          <Carousel
            className={
              imageUrl
                ? ct("rounded", "lt:rounded-tl-none", "lt:rounded-bl-none")
                : undefined
            }
          >
            {products.map((product) => (
              <CarouselMember
                product={product}
                key={product.itemNumber}
                discountCode={discountCode}
              />
            ))}
          </Carousel>
        </div>
      </div>
    </Provider>
  );
};

export default ProductCarouselContainer;
